import { animate, style, transition, trigger } from '@angular/animations';

export let fadeOutWhenDone = trigger('fadeOutWhenDone', [
  transition(':leave', [style({ opacity: 1 }), animate('0.5s ease-in', style({ opacity: 0 }))])
]);
